//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthGateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authMicrosoft(body: AuthMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/auth-microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthMicrosoft(_response);
        });
    }

    protected processAuthMicrosoft(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authMicrosoftNoTenant(body: AuthMicrosoftNoTenantRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/auth-microsoft-no-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthMicrosoftNoTenant(_response);
        });
    }

    protected processAuthMicrosoftNoTenant(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authLocal(body: AuthLocalRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/auth-local";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthLocal(_response);
        });
    }

    protected processAuthLocal(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @return Success
     */
    isAuthed( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Auth/is-authed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAuthed(_response);
        });
    }

    protected processIsAuthed(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getTenants( cancelToken?: CancelToken): Promise<GetUserTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/get-tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<GetUserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsRegularToken( cancelToken?: CancelToken): Promise<GetUserTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/get-tenants-regular-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsRegularToken(_response);
        });
    }

    protected processGetTenantsRegularToken(response: AxiosResponse): Promise<GetUserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    appLogo( cancelToken?: CancelToken): Promise<GetAppLogoResponse> {
        let url_ = this.baseUrl + "/Auth/app-logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppLogo(_response);
        });
    }

    protected processAppLogo(response: AxiosResponse): Promise<GetAppLogoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppLogoResponse.fromJS(resultData200);
            return Promise.resolve<GetAppLogoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppLogoResponse>(null as any);
    }

    /**
     * @return Success
     */
    brandingBySlug(slug: string, cancelToken?: CancelToken): Promise<TenantBrandingDTO> {
        let url_ = this.baseUrl + "/Auth/branding-by-slug/{slug}";
        if (slug === undefined || slug === null)
            throw new globalThis.Error("The parameter 'slug' must be defined.");
        url_ = url_.replace("{slug}", encodeURIComponent("" + slug));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBrandingBySlug(_response);
        });
    }

    protected processBrandingBySlug(response: AxiosResponse): Promise<TenantBrandingDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TenantBrandingDTO.fromJS(resultData200);
            return Promise.resolve<TenantBrandingDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TenantBrandingDTO>(null as any);
    }

    /**
     * @return Success
     */
    me( cancelToken?: CancelToken): Promise<MeResponse> {
        let url_ = this.baseUrl + "/Auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<MeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeResponse.fromJS(resultData200);
            return Promise.resolve<MeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserPassword(body: ChangeUserPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserPasswordResponse> {
        let url_ = this.baseUrl + "/Auth/change-user-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: AxiosResponse): Promise<ChangeUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    storePluginLoginSessionTokens(body: StorePluginSessionTokensRequest | undefined, cancelToken?: CancelToken): Promise<StorePluginSessionTokensResponse> {
        let url_ = this.baseUrl + "/Auth/store-plugin-login-session-tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStorePluginLoginSessionTokens(_response);
        });
    }

    protected processStorePluginLoginSessionTokens(response: AxiosResponse): Promise<StorePluginSessionTokensResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorePluginSessionTokensResponse.fromJS(resultData200);
            return Promise.resolve<StorePluginSessionTokensResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorePluginSessionTokensResponse>(null as any);
    }

    /**
     * @param sessionId (optional) 
     * @return Success
     */
    getPluginLoginSessionTokens(sessionId: string | undefined, cancelToken?: CancelToken): Promise<GetPluginSessionTokensResponse> {
        let url_ = this.baseUrl + "/Auth/get-plugin-login-session-tokens?";
        if (sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPluginLoginSessionTokens(_response);
        });
    }

    protected processGetPluginLoginSessionTokens(response: AxiosResponse): Promise<GetPluginSessionTokensResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPluginSessionTokensResponse.fromJS(resultData200);
            return Promise.resolve<GetPluginSessionTokensResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPluginSessionTokensResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordSendMail(body: ResetUserPasswordSendMailRequest | undefined, cancelToken?: CancelToken): Promise<ResetUserPasswordSendMailResponse> {
        let url_ = this.baseUrl + "/Auth/reset-password-send-mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordSendMail(_response);
        });
    }

    protected processResetPasswordSendMail(response: AxiosResponse): Promise<ResetUserPasswordSendMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetUserPasswordSendMailResponse.fromJS(resultData200);
            return Promise.resolve<ResetUserPasswordSendMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetUserPasswordSendMailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupMicrosoft(body: SignupMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupResponse> {
        let url_ = this.baseUrl + "/Auth/signup-microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupMicrosoft(_response);
        });
    }

    protected processSignupMicrosoft(response: AxiosResponse): Promise<SignupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupResponse.fromJS(resultData200);
            return Promise.resolve<SignupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined, cancelToken?: CancelToken): Promise<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/Auth/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateToken(body: TokenRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Auth/validate-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateToken(_response);
        });
    }

    protected processValidateToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupUserMicrosoft(body: SignupUserMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupUserMicrosoftResponse> {
        let url_ = this.baseUrl + "/Auth/signup-user-microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupUserMicrosoft(_response);
        });
    }

    protected processSignupUserMicrosoft(response: AxiosResponse): Promise<SignupUserMicrosoftResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupUserMicrosoftResponse.fromJS(resultData200);
            return Promise.resolve<SignupUserMicrosoftResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupUserMicrosoftResponse>(null as any);
    }
}

export class PermissionGateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getRoles(tenantId: number, cancelToken?: CancelToken): Promise<GetRolesResponse> {
        let url_ = this.baseUrl + "/Permission/get-roles/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<GetRolesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRolesResponse.fromJS(resultData200);
            return Promise.resolve<GetRolesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRolesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRole(body: CreateRoleRequest | undefined, cancelToken?: CancelToken): Promise<CreateRoleResponse> {
        let url_ = this.baseUrl + "/Permission/create-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: AxiosResponse): Promise<CreateRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateRoleResponse.fromJS(resultData200);
            return Promise.resolve<CreateRoleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateRoleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRole(body: UpdateRoleRequest | undefined, cancelToken?: CancelToken): Promise<UpdateRoleResponse> {
        let url_ = this.baseUrl + "/Permission/update-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRole(_response);
        });
    }

    protected processUpdateRole(response: AxiosResponse): Promise<UpdateRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRoleResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRoleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRoleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRole(body: DeleteRoleRequest | undefined, cancelToken?: CancelToken): Promise<DeleteRoleResponse> {
        let url_ = this.baseUrl + "/Permission/delete-role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<DeleteRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteRoleResponse.fromJS(resultData200);
            return Promise.resolve<DeleteRoleResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteRoleResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRolePermissions(roleId: number, cancelToken?: CancelToken): Promise<GetRolePermissionsResponse> {
        let url_ = this.baseUrl + "/Permission/get-role-permissions/{RoleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{RoleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolePermissions(_response);
        });
    }

    protected processGetRolePermissions(response: AxiosResponse): Promise<GetRolePermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRolePermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetRolePermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRolePermissionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRolePermissions(body: UpdateRolePermissionsRequest | undefined, cancelToken?: CancelToken): Promise<UpdateRolePermissionsResponse> {
        let url_ = this.baseUrl + "/Permission/update-role-permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRolePermissions(_response);
        });
    }

    protected processUpdateRolePermissions(response: AxiosResponse): Promise<UpdateRolePermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRolePermissionsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateRolePermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRolePermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUserRolePermissions( cancelToken?: CancelToken): Promise<GetUserRolePermissionsResponse> {
        let url_ = this.baseUrl + "/Permission/get-user-role-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRolePermissions(_response);
        });
    }

    protected processGetUserRolePermissions(response: AxiosResponse): Promise<GetUserRolePermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserRolePermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserRolePermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserRolePermissionsResponse>(null as any);
    }
}

export class ToolGateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getPortalTools( cancelToken?: CancelToken): Promise<GetToolsResponse> {
        let url_ = this.baseUrl + "/Tool/get-portal-tools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPortalTools(_response);
        });
    }

    protected processGetPortalTools(response: AxiosResponse): Promise<GetToolsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetToolsResponse.fromJS(resultData200);
            return Promise.resolve<GetToolsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetToolsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPortalToolsPermissions( cancelToken?: CancelToken): Promise<GetToolsPermissionsResponse> {
        let url_ = this.baseUrl + "/Tool/get-portal-tools-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPortalToolsPermissions(_response);
        });
    }

    protected processGetPortalToolsPermissions(response: AxiosResponse): Promise<GetToolsPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetToolsPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetToolsPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetToolsPermissionsResponse>(null as any);
    }
}

export class UsersGateApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserTenant(body: ChangeUserTenantRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserTenantResponse> {
        let url_ = this.baseUrl + "/Users/change-user-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserTenant(_response);
        });
    }

    protected processChangeUserTenant(response: AxiosResponse): Promise<ChangeUserTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserTenantResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersTenant( cancelToken?: CancelToken): Promise<GetUsersTenantResponse> {
        let url_ = this.baseUrl + "/Users/get-users-tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersTenant(_response);
        });
    }

    protected processGetUsersTenant(response: AxiosResponse): Promise<GetUsersTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersTenantResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersTenantResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsUser( cancelToken?: CancelToken): Promise<GetTenantsUserResponse> {
        let url_ = this.baseUrl + "/Users/get-tenants-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsUser(_response);
        });
    }

    protected processGetTenantsUser(response: AxiosResponse): Promise<GetTenantsUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsUserResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsAdmin( cancelToken?: CancelToken): Promise<GetTenantsAdminResponse> {
        let url_ = this.baseUrl + "/Users/get-tenants-admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsAdmin(_response);
        });
    }

    protected processGetTenantsAdmin(response: AxiosResponse): Promise<GetTenantsAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantsAdminResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantsAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantsAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsPermissions(tenantId: number, cancelToken?: CancelToken): Promise<GetTenantPermissionSettingsResponse> {
        let url_ = this.baseUrl + "/Users/get-tenants-permissions/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsPermissions(_response);
        });
    }

    protected processGetTenantsPermissions(response: AxiosResponse): Promise<GetTenantPermissionSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantPermissionSettingsResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantPermissionSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantPermissionSettingsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTenantPermissions(body: SaveTenantPermissionSettingsCommand | undefined, cancelToken?: CancelToken): Promise<SaveTenantPermissionSettingsResponse> {
        let url_ = this.baseUrl + "/Users/save-tenant-permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTenantPermissions(_response);
        });
    }

    protected processSaveTenantPermissions(response: AxiosResponse): Promise<SaveTenantPermissionSettingsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveTenantPermissionSettingsResponse.fromJS(resultData200);
            return Promise.resolve<SaveTenantPermissionSettingsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveTenantPermissionSettingsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantHiddenPermissions(tenantId: number, cancelToken?: CancelToken): Promise<GetTenantHiddenPermissionsResponse> {
        let url_ = this.baseUrl + "/Users/get-tenant-hidden-permissions/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantHiddenPermissions(_response);
        });
    }

    protected processGetTenantHiddenPermissions(response: AxiosResponse): Promise<GetTenantHiddenPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantHiddenPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantHiddenPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantHiddenPermissionsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTenantHiddenPermissions(body: SaveTenantHiddenPermissionsCommand | undefined, cancelToken?: CancelToken): Promise<SaveTenantHiddenPermissionsResponse> {
        let url_ = this.baseUrl + "/Users/save-tenant-hidden-permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTenantHiddenPermissions(_response);
        });
    }

    protected processSaveTenantHiddenPermissions(response: AxiosResponse): Promise<SaveTenantHiddenPermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveTenantHiddenPermissionsResponse.fromJS(resultData200);
            return Promise.resolve<SaveTenantHiddenPermissionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveTenantHiddenPermissionsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPricingDatabaseSharing(tenantId: number, cancelToken?: CancelToken): Promise<GetPricingDatabaseSharingResponse> {
        let url_ = this.baseUrl + "/Users/get-pricing-database-sharing/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPricingDatabaseSharing(_response);
        });
    }

    protected processGetPricingDatabaseSharing(response: AxiosResponse): Promise<GetPricingDatabaseSharingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPricingDatabaseSharingResponse.fromJS(resultData200);
            return Promise.resolve<GetPricingDatabaseSharingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPricingDatabaseSharingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePricingDatabaseSharing(body: SavePricingDatabaseSharingCommand | undefined, cancelToken?: CancelToken): Promise<SavePricingDatabaseSharingResponse> {
        let url_ = this.baseUrl + "/Users/save-pricing-database-sharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSavePricingDatabaseSharing(_response);
        });
    }

    protected processSavePricingDatabaseSharing(response: AxiosResponse): Promise<SavePricingDatabaseSharingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SavePricingDatabaseSharingResponse.fromJS(resultData200);
            return Promise.resolve<SavePricingDatabaseSharingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SavePricingDatabaseSharingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveUserData(body: SaveUserDataRequest | undefined, cancelToken?: CancelToken): Promise<SaveUserDataResponse> {
        let url_ = this.baseUrl + "/Users/save-user-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserData(_response);
        });
    }

    protected processSaveUserData(response: AxiosResponse): Promise<SaveUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveUserDataResponse.fromJS(resultData200);
            return Promise.resolve<SaveUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveUserDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordUser(body: ResetPasswordUserRequest | undefined, cancelToken?: CancelToken): Promise<ResetPasswordUserResponse> {
        let url_ = this.baseUrl + "/Users/reset-password-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordUser(_response);
        });
    }

    protected processResetPasswordUser(response: AxiosResponse): Promise<ResetPasswordUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordUserResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordUserResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getSignupUserData(token: string | undefined, cancelToken?: CancelToken): Promise<GetSignupUserDataResponse> {
        let url_ = this.baseUrl + "/Users/get-signup-user-data?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignupUserData(_response);
        });
    }

    protected processGetSignupUserData(response: AxiosResponse): Promise<GetSignupUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSignupUserDataResponse.fromJS(resultData200);
            return Promise.resolve<GetSignupUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSignupUserDataResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param signupToken (optional) 
     * @param newPass (optional) 
     * @return Success
     */
    setUserPassword(id: number | undefined, signupToken: string | undefined, newPass: string | undefined, cancelToken?: CancelToken): Promise<SetUserPasswordResponse> {
        let url_ = this.baseUrl + "/Users/set-user-password?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (signupToken === null)
            throw new globalThis.Error("The parameter 'signupToken' cannot be null.");
        else if (signupToken !== undefined)
            url_ += "SignupToken=" + encodeURIComponent("" + signupToken) + "&";
        if (newPass === null)
            throw new globalThis.Error("The parameter 'newPass' cannot be null.");
        else if (newPass !== undefined)
            url_ += "NewPass=" + encodeURIComponent("" + newPass) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserPassword(_response);
        });
    }

    protected processSetUserPassword(response: AxiosResponse): Promise<SetUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<SetUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetUserPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserSendSignupMail(body: CreateUserSendSignupMailRequest | undefined, cancelToken?: CancelToken): Promise<CreateUserSendSignupMailResponse> {
        let url_ = this.baseUrl + "/Users/create-user-send-signup-mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserSendSignupMail(_response);
        });
    }

    protected processCreateUserSendSignupMail(response: AxiosResponse): Promise<CreateUserSendSignupMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserSendSignupMailResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserSendSignupMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserSendSignupMailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantRequest | undefined, cancelToken?: CancelToken): Promise<CreateTenantResponse> {
        let url_ = this.baseUrl + "/Users/create-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: AxiosResponse): Promise<CreateTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTenantResponse.fromJS(resultData200);
            return Promise.resolve<CreateTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserToTenant(body: AddUserToTenantRequest | undefined, cancelToken?: CancelToken): Promise<AddUserToTenantResponse> {
        let url_ = this.baseUrl + "/Users/add-user-to-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUserToTenant(_response);
        });
    }

    protected processAddUserToTenant(response: AxiosResponse): Promise<AddUserToTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUserToTenantResponse.fromJS(resultData200);
            return Promise.resolve<AddUserToTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUserToTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renameTenant(body: RenameTenantRequest | undefined, cancelToken?: CancelToken): Promise<RenameTenantResponse> {
        let url_ = this.baseUrl + "/Users/rename-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameTenant(_response);
        });
    }

    protected processRenameTenant(response: AxiosResponse): Promise<RenameTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RenameTenantResponse.fromJS(resultData200);
            return Promise.resolve<RenameTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RenameTenantResponse>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantDocumentationStages(tenantId: number | undefined, cancelToken?: CancelToken): Promise<GetTenantDocumentationStagesResponse> {
        let url_ = this.baseUrl + "/Users/get-tenant-documentation-stages?";
        if (tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantDocumentationStages(_response);
        });
    }

    protected processGetTenantDocumentationStages(response: AxiosResponse): Promise<GetTenantDocumentationStagesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantDocumentationStagesResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantDocumentationStagesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantDocumentationStagesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTenantDocumentationStages(body: SaveTenantDocumentationStagesRequest | undefined, cancelToken?: CancelToken): Promise<SaveDocumentationStagesResponse> {
        let url_ = this.baseUrl + "/Users/save-tenant-documentation-stages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTenantDocumentationStages(_response);
        });
    }

    protected processSaveTenantDocumentationStages(response: AxiosResponse): Promise<SaveDocumentationStagesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveDocumentationStagesResponse.fromJS(resultData200);
            return Promise.resolve<SaveDocumentationStagesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveDocumentationStagesResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteTenant(tenantId: number, cancelToken?: CancelToken): Promise<DeleteTenantResponse> {
        let url_ = this.baseUrl + "/Users/delete-tenant/{TenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new globalThis.Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{TenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: AxiosResponse): Promise<DeleteTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteTenantResponse.fromJS(resultData200);
            return Promise.resolve<DeleteTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteTenantResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserFromTenant(body: RemoveUserFromTenantRequest | undefined, cancelToken?: CancelToken): Promise<RemoveUserFromTenantResponse> {
        let url_ = this.baseUrl + "/Users/remove-user-from-tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserFromTenant(_response);
        });
    }

    protected processRemoveUserFromTenant(response: AxiosResponse): Promise<RemoveUserFromTenantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RemoveUserFromTenantResponse.fromJS(resultData200);
            return Promise.resolve<RemoveUserFromTenantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveUserFromTenantResponse>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    getResetPasswordUserData(token: string | undefined, cancelToken?: CancelToken): Promise<GetResetPasswordUserDataResponse> {
        let url_ = this.baseUrl + "/Users/get-reset-password-user-data?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResetPasswordUserData(_response);
        });
    }

    protected processGetResetPasswordUserData(response: AxiosResponse): Promise<GetResetPasswordUserDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetResetPasswordUserDataResponse.fromJS(resultData200);
            return Promise.resolve<GetResetPasswordUserDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetResetPasswordUserDataResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrCreateUsers(body: AddOrCreateUsersRequest | undefined, cancelToken?: CancelToken): Promise<AddOrCreateUsersResponse> {
        let url_ = this.baseUrl + "/Users/add-or-create-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrCreateUsers(_response);
        });
    }

    protected processAddOrCreateUsers(response: AxiosResponse): Promise<AddOrCreateUsersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddOrCreateUsersResponse.fromJS(resultData200);
            return Promise.resolve<AddOrCreateUsersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddOrCreateUsersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantBranding( cancelToken?: CancelToken): Promise<GetTenantBrandingResponse> {
        let url_ = this.baseUrl + "/Users/get-tenant-branding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantBranding(_response);
        });
    }

    protected processGetTenantBranding(response: AxiosResponse): Promise<GetTenantBrandingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTenantBrandingResponse.fromJS(resultData200);
            return Promise.resolve<GetTenantBrandingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTenantBrandingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTenantBranding(body: SaveTenantBrandingCommand | undefined, cancelToken?: CancelToken): Promise<SaveTenantBrandingResponse> {
        let url_ = this.baseUrl + "/Users/save-tenant-branding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTenantBranding(_response);
        });
    }

    protected processSaveTenantBranding(response: AxiosResponse): Promise<SaveTenantBrandingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaveTenantBrandingResponse.fromJS(resultData200);
            return Promise.resolve<SaveTenantBrandingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaveTenantBrandingResponse>(null as any);
    }

    /**
     * @return Success
     */
    resetTenantBranding( cancelToken?: CancelToken): Promise<ResetTenantBrandingResponse> {
        let url_ = this.baseUrl + "/Users/reset-tenant-branding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetTenantBranding(_response);
        });
    }

    protected processResetTenantBranding(response: AxiosResponse): Promise<ResetTenantBrandingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetTenantBrandingResponse.fromJS(resultData200);
            return Promise.resolve<ResetTenantBrandingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetTenantBrandingResponse>(null as any);
    }
}

export class AddOrCreateUsersRequest implements IAddOrCreateUsersRequest {
    tenantId?: number | undefined;
    users?: UserCreateModelDTO[] | undefined;

    constructor(data?: IAddOrCreateUsersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserCreateModelDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddOrCreateUsersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrCreateUsersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddOrCreateUsersRequest {
    tenantId?: number | undefined;
    users?: UserCreateModelDTO[] | undefined;
}

export class AddOrCreateUsersResponse implements IAddOrCreateUsersResponse {
    ok?: boolean;
    createErrors?: CreateInfo[] | undefined;

    constructor(data?: IAddOrCreateUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            if (Array.isArray(_data["createErrors"])) {
                this.createErrors = [] as any;
                for (let item of _data["createErrors"])
                    this.createErrors!.push(CreateInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddOrCreateUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrCreateUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        if (Array.isArray(this.createErrors)) {
            data["createErrors"] = [];
            for (let item of this.createErrors)
                data["createErrors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddOrCreateUsersResponse {
    ok?: boolean;
    createErrors?: CreateInfo[] | undefined;
}

export class AddUserToTenantRequest implements IAddUserToTenantRequest {
    email?: string | undefined;
    tenantId?: number | undefined;
    sendMail?: boolean;
    role?: string | undefined;

    constructor(data?: IAddUserToTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.tenantId = _data["tenantId"];
            this.sendMail = _data["sendMail"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): AddUserToTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["tenantId"] = this.tenantId;
        data["sendMail"] = this.sendMail;
        data["role"] = this.role;
        return data;
    }
}

export interface IAddUserToTenantRequest {
    email?: string | undefined;
    tenantId?: number | undefined;
    sendMail?: boolean;
    role?: string | undefined;
}

export class AddUserToTenantResponse implements IAddUserToTenantResponse {
    ok?: boolean;
    alreadyAdded?: boolean;
    userId?: number | undefined;
    roleNotFound?: boolean;

    constructor(data?: IAddUserToTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.alreadyAdded = _data["alreadyAdded"];
            this.userId = _data["userId"];
            this.roleNotFound = _data["roleNotFound"];
        }
    }

    static fromJS(data: any): AddUserToTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserToTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["alreadyAdded"] = this.alreadyAdded;
        data["userId"] = this.userId;
        data["roleNotFound"] = this.roleNotFound;
        return data;
    }
}

export interface IAddUserToTenantResponse {
    ok?: boolean;
    alreadyAdded?: boolean;
    userId?: number | undefined;
    roleNotFound?: boolean;
}

export class AuthLocalRequest implements IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthLocalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthLocalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLocalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthMicrosoftNoTenantRequest implements IAuthMicrosoftNoTenantRequest {
    token?: string | undefined;

    constructor(data?: IAuthMicrosoftNoTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): AuthMicrosoftNoTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMicrosoftNoTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface IAuthMicrosoftNoTenantRequest {
    token?: string | undefined;
}

export class AuthMicrosoftRequest implements IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthResponse implements IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : undefined as any;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.resetPassword = _data["resetPassword"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : undefined as any;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantId"] = this.tenantId;
        data["resetPassword"] = this.resetPassword;
        return data;
    }
}

export interface IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;
}

export class ChangeUserPasswordRequest implements IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangeUserPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangeUserPasswordResponse implements IChangeUserPasswordResponse {
    ok?: boolean;

    constructor(data?: IChangeUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangeUserPasswordResponse {
    ok?: boolean;
}

export class ChangeUserTenantRequest implements IChangeUserTenantRequest {
    tenantId?: number;

    constructor(data?: IChangeUserTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ChangeUserTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IChangeUserTenantRequest {
    tenantId?: number;
}

export class ChangeUserTenantResponse implements IChangeUserTenantResponse {
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenantId?: number;

    constructor(data?: IChangeUserTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : undefined as any;
            this.refreshToken = _data["refreshToken"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ChangeUserTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : undefined as any;
        data["refreshToken"] = this.refreshToken;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IChangeUserTenantResponse {
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenantId?: number;
}

export enum CreateError {
    None = 0,
    InvalidEmail = 1,
    UserAlreadyExists = 2,
    UnknownError = 3,
    RoleNotFound = 4,
}

export class CreateInfo implements ICreateInfo {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    error?: CreateError;

    constructor(data?: ICreateInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateInfo {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    error?: CreateError;
}

export class CreateRoleRequest implements ICreateRoleRequest {
    name?: string | undefined;
    tenantId?: number;

    constructor(data?: ICreateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateRoleRequest {
    name?: string | undefined;
    tenantId?: number;
}

export class CreateRoleResponse implements ICreateRoleResponse {
    role?: RoleListDTO;

    constructor(data?: ICreateRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleListDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateRoleResponse {
    role?: RoleListDTO;
}

export class CreateTenantRequest implements ICreateTenantRequest {
    name?: string | undefined;
    rsdApiKey?: string | undefined;

    constructor(data?: ICreateTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.rsdApiKey = _data["rsdApiKey"];
        }
    }

    static fromJS(data: any): CreateTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["rsdApiKey"] = this.rsdApiKey;
        return data;
    }
}

export interface ICreateTenantRequest {
    name?: string | undefined;
    rsdApiKey?: string | undefined;
}

export class CreateTenantResponse implements ICreateTenantResponse {
    ok?: boolean;
    tenantId?: number;

    constructor(data?: ICreateTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateTenantResponse {
    ok?: boolean;
    tenantId?: number;
}

export class CreateUserSendSignupMailRequest implements ICreateUserSendSignupMailRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    localLogin?: boolean;
    msLogin?: boolean;
    tenantId?: number | undefined;
    language?: string | undefined;
    role?: string | undefined;

    constructor(data?: ICreateUserSendSignupMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.localLogin = _data["localLogin"];
            this.msLogin = _data["msLogin"];
            this.tenantId = _data["tenantId"];
            this.language = _data["language"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CreateUserSendSignupMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSendSignupMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["localLogin"] = this.localLogin;
        data["msLogin"] = this.msLogin;
        data["tenantId"] = this.tenantId;
        data["language"] = this.language;
        data["role"] = this.role;
        return data;
    }
}

export interface ICreateUserSendSignupMailRequest {
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    localLogin?: boolean;
    msLogin?: boolean;
    tenantId?: number | undefined;
    language?: string | undefined;
    role?: string | undefined;
}

export class CreateUserSendSignupMailResponse implements ICreateUserSendSignupMailResponse {
    ok?: boolean;
    roleNotFound?: boolean;

    constructor(data?: ICreateUserSendSignupMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.roleNotFound = _data["roleNotFound"];
        }
    }

    static fromJS(data: any): CreateUserSendSignupMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserSendSignupMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["roleNotFound"] = this.roleNotFound;
        return data;
    }
}

export interface ICreateUserSendSignupMailResponse {
    ok?: boolean;
    roleNotFound?: boolean;
}

export class DataStandardPermissionDTO implements IDataStandardPermissionDTO {
    id?: number;
    name?: string | undefined;
    granted?: boolean;

    constructor(data?: IDataStandardPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.granted = _data["granted"];
        }
    }

    static fromJS(data: any): DataStandardPermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DataStandardPermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["granted"] = this.granted;
        return data;
    }
}

export interface IDataStandardPermissionDTO {
    id?: number;
    name?: string | undefined;
    granted?: boolean;
}

export class DateOnlyDto implements IDateOnlyDto {
    year?: number;
    month?: number;
    day?: number;

    constructor(data?: IDateOnlyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
        }
    }

    static fromJS(data: any): DateOnlyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateOnlyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        return data;
    }
}

export interface IDateOnlyDto {
    year?: number;
    month?: number;
    day?: number;
}

export class DeleteRoleRequest implements IDeleteRoleRequest {
    id?: number;

    constructor(data?: IDeleteRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteRoleRequest {
    id?: number;
}

export class DeleteRoleResponse implements IDeleteRoleResponse {
    success?: boolean;

    constructor(data?: IDeleteRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteRoleResponse {
    success?: boolean;
}

export class DeleteTenantResponse implements IDeleteTenantResponse {
    ok?: boolean;

    constructor(data?: IDeleteTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteTenantResponse {
    ok?: boolean;
}

export class DocumentationStageDTO implements IDocumentationStageDTO {
    id?: number;
    name?: string | undefined;
    sortOrder?: number;

    constructor(data?: IDocumentationStageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DocumentationStageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentationStageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IDocumentationStageDTO {
    id?: number;
    name?: string | undefined;
    sortOrder?: number;
}

export enum DocumentationStagesSaveError {
    EmptyName = 0,
    DuplicateName = 1,
    NameTooLong = 2,
    StageInUse = 3,
}

export class GetAppLogoResponse implements IGetAppLogoResponse {
    base64?: string | undefined;

    constructor(data?: IGetAppLogoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): GetAppLogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppLogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IGetAppLogoResponse {
    base64?: string | undefined;
}

export class GetPluginSessionTokensResponse implements IGetPluginSessionTokensResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;
    validUntil?: Date;

    constructor(data?: IGetPluginSessionTokensResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : undefined as any;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetPluginSessionTokensResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPluginSessionTokensResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expires"] = this.expires ? this.expires.toISOString() : undefined as any;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetPluginSessionTokensResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;
    validUntil?: Date;
}

export class GetPricingDatabaseSharingResponse implements IGetPricingDatabaseSharingResponse {
    pricingDatabases?: SharedPricingDatabaseDTO[] | undefined;

    constructor(data?: IGetPricingDatabaseSharingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pricingDatabases"])) {
                this.pricingDatabases = [] as any;
                for (let item of _data["pricingDatabases"])
                    this.pricingDatabases!.push(SharedPricingDatabaseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPricingDatabaseSharingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPricingDatabaseSharingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pricingDatabases)) {
            data["pricingDatabases"] = [];
            for (let item of this.pricingDatabases)
                data["pricingDatabases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetPricingDatabaseSharingResponse {
    pricingDatabases?: SharedPricingDatabaseDTO[] | undefined;
}

export class GetResetPasswordUserDataResponse implements IGetResetPasswordUserDataResponse {
    userId?: number;

    constructor(data?: IGetResetPasswordUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GetResetPasswordUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResetPasswordUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface IGetResetPasswordUserDataResponse {
    userId?: number;
}

export class GetRolePermissionsResponse implements IGetRolePermissionsResponse {
    role?: RoleDTO;

    constructor(data?: IGetRolePermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetRolePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolePermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetRolePermissionsResponse {
    role?: RoleDTO;
}

export class GetRolesResponse implements IGetRolesResponse {
    roles?: RoleListDTO[] | undefined;

    constructor(data?: IGetRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleListDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetRolesResponse {
    roles?: RoleListDTO[] | undefined;
}

export class GetSignupUserDataResponse implements IGetSignupUserDataResponse {
    userId?: number;
    localLogin?: boolean;
    msLogin?: boolean;

    constructor(data?: IGetSignupUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.localLogin = _data["localLogin"];
            this.msLogin = _data["msLogin"];
        }
    }

    static fromJS(data: any): GetSignupUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSignupUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["localLogin"] = this.localLogin;
        data["msLogin"] = this.msLogin;
        return data;
    }
}

export interface IGetSignupUserDataResponse {
    userId?: number;
    localLogin?: boolean;
    msLogin?: boolean;
}

export class GetTenantBrandingResponse implements IGetTenantBrandingResponse {
    branding?: TenantBrandingDTO;

    constructor(data?: IGetTenantBrandingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branding = _data["branding"] ? TenantBrandingDTO.fromJS(_data["branding"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTenantBrandingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantBrandingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branding"] = this.branding ? this.branding.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTenantBrandingResponse {
    branding?: TenantBrandingDTO;
}

export class GetTenantDocumentationStagesResponse implements IGetTenantDocumentationStagesResponse {
    stages?: DocumentationStageDTO[] | undefined;

    constructor(data?: IGetTenantDocumentationStagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(DocumentationStageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantDocumentationStagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantDocumentationStagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantDocumentationStagesResponse {
    stages?: DocumentationStageDTO[] | undefined;
}

export class GetTenantHiddenPermissionsResponse implements IGetTenantHiddenPermissionsResponse {
    permissions?: TenantPermissionVisibilityDTO[] | undefined;

    constructor(data?: IGetTenantHiddenPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(TenantPermissionVisibilityDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantHiddenPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantHiddenPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantHiddenPermissionsResponse {
    permissions?: TenantPermissionVisibilityDTO[] | undefined;
}

export class GetTenantPermissionSettingsResponse implements IGetTenantPermissionSettingsResponse {
    restrictModules?: boolean;
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;
    bimValidatorExpiryDate?: DateOnlyDto;
    budgetingExpiryDate?: DateOnlyDto;
    curveSolverExpiryDate?: DateOnlyDto;
    isoAnalyzerExpiryDate?: DateOnlyDto;
    slopeGuardExpiryDate?: DateOnlyDto;
    enumerationsAdministrationExpiryDate?: DateOnlyDto;
    ovCeExpiryDate?: DateOnlyDto;
    bimVitrinaExpiryDate?: DateOnlyDto;
    aiAskerExpiryDate?: DateOnlyDto;

    constructor(data?: IGetTenantPermissionSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.restrictModules = _data["restrictModules"];
            this.hasBimValidator = _data["hasBimValidator"];
            this.hasBudgeting = _data["hasBudgeting"];
            this.hasCurveSolver = _data["hasCurveSolver"];
            this.hasIsoAnalyzer = _data["hasIsoAnalyzer"];
            this.hasSlopeGuard = _data["hasSlopeGuard"];
            this.hasEnumerationsAdministration = _data["hasEnumerationsAdministration"];
            this.hasOvCe = _data["hasOvCe"];
            this.hasBimVitrina = _data["hasBimVitrina"];
            this.hasAiAsker = _data["hasAiAsker"];
            this.bimValidatorExpiryDate = _data["bimValidatorExpiryDate"] ? DateOnlyDto.fromJS(_data["bimValidatorExpiryDate"]) : undefined as any;
            this.budgetingExpiryDate = _data["budgetingExpiryDate"] ? DateOnlyDto.fromJS(_data["budgetingExpiryDate"]) : undefined as any;
            this.curveSolverExpiryDate = _data["curveSolverExpiryDate"] ? DateOnlyDto.fromJS(_data["curveSolverExpiryDate"]) : undefined as any;
            this.isoAnalyzerExpiryDate = _data["isoAnalyzerExpiryDate"] ? DateOnlyDto.fromJS(_data["isoAnalyzerExpiryDate"]) : undefined as any;
            this.slopeGuardExpiryDate = _data["slopeGuardExpiryDate"] ? DateOnlyDto.fromJS(_data["slopeGuardExpiryDate"]) : undefined as any;
            this.enumerationsAdministrationExpiryDate = _data["enumerationsAdministrationExpiryDate"] ? DateOnlyDto.fromJS(_data["enumerationsAdministrationExpiryDate"]) : undefined as any;
            this.ovCeExpiryDate = _data["ovCeExpiryDate"] ? DateOnlyDto.fromJS(_data["ovCeExpiryDate"]) : undefined as any;
            this.bimVitrinaExpiryDate = _data["bimVitrinaExpiryDate"] ? DateOnlyDto.fromJS(_data["bimVitrinaExpiryDate"]) : undefined as any;
            this.aiAskerExpiryDate = _data["aiAskerExpiryDate"] ? DateOnlyDto.fromJS(_data["aiAskerExpiryDate"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetTenantPermissionSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantPermissionSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["restrictModules"] = this.restrictModules;
        data["hasBimValidator"] = this.hasBimValidator;
        data["hasBudgeting"] = this.hasBudgeting;
        data["hasCurveSolver"] = this.hasCurveSolver;
        data["hasIsoAnalyzer"] = this.hasIsoAnalyzer;
        data["hasSlopeGuard"] = this.hasSlopeGuard;
        data["hasEnumerationsAdministration"] = this.hasEnumerationsAdministration;
        data["hasOvCe"] = this.hasOvCe;
        data["hasBimVitrina"] = this.hasBimVitrina;
        data["hasAiAsker"] = this.hasAiAsker;
        data["bimValidatorExpiryDate"] = this.bimValidatorExpiryDate ? this.bimValidatorExpiryDate.toJSON() : undefined as any;
        data["budgetingExpiryDate"] = this.budgetingExpiryDate ? this.budgetingExpiryDate.toJSON() : undefined as any;
        data["curveSolverExpiryDate"] = this.curveSolverExpiryDate ? this.curveSolverExpiryDate.toJSON() : undefined as any;
        data["isoAnalyzerExpiryDate"] = this.isoAnalyzerExpiryDate ? this.isoAnalyzerExpiryDate.toJSON() : undefined as any;
        data["slopeGuardExpiryDate"] = this.slopeGuardExpiryDate ? this.slopeGuardExpiryDate.toJSON() : undefined as any;
        data["enumerationsAdministrationExpiryDate"] = this.enumerationsAdministrationExpiryDate ? this.enumerationsAdministrationExpiryDate.toJSON() : undefined as any;
        data["ovCeExpiryDate"] = this.ovCeExpiryDate ? this.ovCeExpiryDate.toJSON() : undefined as any;
        data["bimVitrinaExpiryDate"] = this.bimVitrinaExpiryDate ? this.bimVitrinaExpiryDate.toJSON() : undefined as any;
        data["aiAskerExpiryDate"] = this.aiAskerExpiryDate ? this.aiAskerExpiryDate.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetTenantPermissionSettingsResponse {
    restrictModules?: boolean;
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;
    bimValidatorExpiryDate?: DateOnlyDto;
    budgetingExpiryDate?: DateOnlyDto;
    curveSolverExpiryDate?: DateOnlyDto;
    isoAnalyzerExpiryDate?: DateOnlyDto;
    slopeGuardExpiryDate?: DateOnlyDto;
    enumerationsAdministrationExpiryDate?: DateOnlyDto;
    ovCeExpiryDate?: DateOnlyDto;
    bimVitrinaExpiryDate?: DateOnlyDto;
    aiAskerExpiryDate?: DateOnlyDto;
}

export class GetTenantsAdminResponse implements IGetTenantsAdminResponse {
    tenants?: TenantDTO[] | undefined;

    constructor(data?: IGetTenantsAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantsAdminResponse {
    tenants?: TenantDTO[] | undefined;
}

export class GetTenantsUserResponse implements IGetTenantsUserResponse {
    tenants?: TenantDTO[] | undefined;

    constructor(data?: IGetTenantsUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetTenantsUserResponse {
    tenants?: TenantDTO[] | undefined;
}

export class GetToolsPermissionsResponse implements IGetToolsPermissionsResponse {
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;

    constructor(data?: IGetToolsPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasBimValidator = _data["hasBimValidator"];
            this.hasBudgeting = _data["hasBudgeting"];
            this.hasCurveSolver = _data["hasCurveSolver"];
            this.hasIsoAnalyzer = _data["hasIsoAnalyzer"];
            this.hasSlopeGuard = _data["hasSlopeGuard"];
            this.hasEnumerationsAdministration = _data["hasEnumerationsAdministration"];
            this.hasOvCe = _data["hasOvCe"];
            this.hasBimVitrina = _data["hasBimVitrina"];
            this.hasAiAsker = _data["hasAiAsker"];
        }
    }

    static fromJS(data: any): GetToolsPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetToolsPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasBimValidator"] = this.hasBimValidator;
        data["hasBudgeting"] = this.hasBudgeting;
        data["hasCurveSolver"] = this.hasCurveSolver;
        data["hasIsoAnalyzer"] = this.hasIsoAnalyzer;
        data["hasSlopeGuard"] = this.hasSlopeGuard;
        data["hasEnumerationsAdministration"] = this.hasEnumerationsAdministration;
        data["hasOvCe"] = this.hasOvCe;
        data["hasBimVitrina"] = this.hasBimVitrina;
        data["hasAiAsker"] = this.hasAiAsker;
        return data;
    }
}

export interface IGetToolsPermissionsResponse {
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;
}

export class GetToolsResponse implements IGetToolsResponse {
    tools?: PortalToolDto[] | undefined;

    constructor(data?: IGetToolsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tools"])) {
                this.tools = [] as any;
                for (let item of _data["tools"])
                    this.tools!.push(PortalToolDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetToolsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetToolsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tools)) {
            data["tools"] = [];
            for (let item of this.tools)
                data["tools"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetToolsResponse {
    tools?: PortalToolDto[] | undefined;
}

export class GetUserRolePermissionsResponse implements IGetUserRolePermissionsResponse {
    role?: RoleDTO;

    constructor(data?: IGetUserRolePermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUserRolePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserRolePermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUserRolePermissionsResponse {
    role?: RoleDTO;
}

export class GetUserTenantsResponse implements IGetUserTenantsResponse {
    tenants?: TenantListDto[] | undefined;

    constructor(data?: IGetUserTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetUserTenantsResponse {
    tenants?: TenantListDto[] | undefined;
}

export class GetUsersTenantResponse implements IGetUsersTenantResponse {
    tenant?: TenantDTO;

    constructor(data?: IGetUsersTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"] ? TenantDTO.fromJS(_data["tenant"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetUsersTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetUsersTenantResponse {
    tenant?: TenantDTO;
}

export class MeResponse implements IMeResponse {
    id?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    initials?: string | undefined;
    tenantName?: string | undefined;
    tenantId?: number;
    isAdmin?: boolean;
    canCreateTenants?: boolean;
    isTenantManager?: boolean;
    canCreateUsers?: boolean;
    language?: string | undefined;

    constructor(data?: IMeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.initials = _data["initials"];
            this.tenantName = _data["tenantName"];
            this.tenantId = _data["tenantId"];
            this.isAdmin = _data["isAdmin"];
            this.canCreateTenants = _data["canCreateTenants"];
            this.isTenantManager = _data["isTenantManager"];
            this.canCreateUsers = _data["canCreateUsers"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): MeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["initials"] = this.initials;
        data["tenantName"] = this.tenantName;
        data["tenantId"] = this.tenantId;
        data["isAdmin"] = this.isAdmin;
        data["canCreateTenants"] = this.canCreateTenants;
        data["isTenantManager"] = this.isTenantManager;
        data["canCreateUsers"] = this.canCreateUsers;
        data["language"] = this.language;
        return data;
    }
}

export interface IMeResponse {
    id?: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    initials?: string | undefined;
    tenantName?: string | undefined;
    tenantId?: number;
    isAdmin?: boolean;
    canCreateTenants?: boolean;
    isTenantManager?: boolean;
    canCreateUsers?: boolean;
    language?: string | undefined;
}

export enum ModuleType {
    DataStandards = 1,
    BimValidator = 2,
    GpkValidator = 3,
    SlopeGuard = 4,
    Enumerations = 5,
    Standalyzer = 6,
    BimVitrina = 7,
    Sumec = 8,
    BimComplete = 9,
    ModelsAdministration = 10,
    AiAsker = 11,
}

export class PermissionDTO implements IPermissionDTO {
    id?: number;
    name?: string | undefined;
    permissionType?: PermissionType;
    moduleType?: ModuleType;
    granted?: boolean;

    constructor(data?: IPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.permissionType = _data["permissionType"];
            this.moduleType = _data["moduleType"];
            this.granted = _data["granted"];
        }
    }

    static fromJS(data: any): PermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["permissionType"] = this.permissionType;
        data["moduleType"] = this.moduleType;
        data["granted"] = this.granted;
        return data;
    }
}

export interface IPermissionDTO {
    id?: number;
    name?: string | undefined;
    permissionType?: PermissionType;
    moduleType?: ModuleType;
    granted?: boolean;
}

export enum PermissionType {
    CreateDataStandard = 1,
    DeleteForeignDataStandard = 2,
    EditForeignDataStandard = 3,
    AddIsoStandard = 4,
    RunStandardUpdate = 5,
    ImportIsoStandardsExcel = 6,
    EditIsoStandard = 7,
    DeleteIsoStandard = 8,
    CreateMappingBimComplete = 9,
    EditMappingBimComplete = 10,
    DeleteMappingBimComplete = 11,
    ImportStandardBimComplete = 12,
    AddPropertiesBimComplete = 13,
    CreateRouteBimComplete = 14,
    EditRouteBimComplete = 15,
    DeleteRouteBimComplete = 16,
    UpdateElementFromProjectBimComplete = 17,
    DeleteElementPropertiesBimComplete = 18,
    ImportExcelBimComplete = 19,
    CreateEnumaration = 20,
    UpdateEnumaration = 21,
    DeleteEnumaration = 22,
    ImportExcelEnumaration = 23,
    ExportStandardsExcel = 24,
    DeleteModelsAdministration = 25,
    DownloadModelsAdministration = 26,
    ShareDataStandards = 27,
    CopySharedDataStandards = 28,
    SharePricingDatabaseSavedPositions = 29,
    CopySharedPricingDatabaseSavedPositions = 30,
    ManageTenantSharedPricingDatabaseSavedPositions = 31,
    ShareClassificationSavedPositions = 32,
    CopySharedClassificationSavedPositions = 33,
    ManageTenantSharedClassificationSavedPositions = 34,
    CreatePricingDatabase = 35,
    UpdatePricingDatabase = 36,
    DeletePricingDatabase = 37,
    CreatePricingDatabaseItem = 38,
    UpdatePricingDatabaseItem = 39,
    DeletePricingDatabaseItem = 40,
}

export class PortalToolDto implements IPortalToolDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    imageUrl?: string | undefined;
    includeLoginInfos?: boolean;

    constructor(data?: IPortalToolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.imageUrl = _data["imageUrl"];
            this.includeLoginInfos = _data["includeLoginInfos"];
        }
    }

    static fromJS(data: any): PortalToolDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalToolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        data["imageUrl"] = this.imageUrl;
        data["includeLoginInfos"] = this.includeLoginInfos;
        return data;
    }
}

export interface IPortalToolDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    imageUrl?: string | undefined;
    includeLoginInfos?: boolean;
}

export class PricingDatabasePermissionDTO implements IPricingDatabasePermissionDTO {
    id?: number;
    name?: string | undefined;
    granted?: boolean;
    isShared?: boolean;
    ownerTenantName?: string | undefined;

    constructor(data?: IPricingDatabasePermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.granted = _data["granted"];
            this.isShared = _data["isShared"];
            this.ownerTenantName = _data["ownerTenantName"];
        }
    }

    static fromJS(data: any): PricingDatabasePermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PricingDatabasePermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["granted"] = this.granted;
        data["isShared"] = this.isShared;
        data["ownerTenantName"] = this.ownerTenantName;
        return data;
    }
}

export interface IPricingDatabasePermissionDTO {
    id?: number;
    name?: string | undefined;
    granted?: boolean;
    isShared?: boolean;
    ownerTenantName?: string | undefined;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class RemoveUserFromTenantRequest implements IRemoveUserFromTenantRequest {
    userId?: number;
    tenantId?: number;

    constructor(data?: IRemoveUserFromTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): RemoveUserFromTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserFromTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IRemoveUserFromTenantRequest {
    userId?: number;
    tenantId?: number;
}

export class RemoveUserFromTenantResponse implements IRemoveUserFromTenantResponse {
    ok?: boolean;

    constructor(data?: IRemoveUserFromTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RemoveUserFromTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserFromTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRemoveUserFromTenantResponse {
    ok?: boolean;
}

export class RenameTenantRequest implements IRenameTenantRequest {
    tenantId?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;

    constructor(data?: IRenameTenantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.rsdApiKey = _data["rsdApiKey"];
        }
    }

    static fromJS(data: any): RenameTenantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTenantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["rsdApiKey"] = this.rsdApiKey;
        return data;
    }
}

export interface IRenameTenantRequest {
    tenantId?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;
}

export class RenameTenantResponse implements IRenameTenantResponse {
    ok?: boolean;

    constructor(data?: IRenameTenantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): RenameTenantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTenantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IRenameTenantResponse {
    ok?: boolean;
}

export class ResetPasswordUserRequest implements IResetPasswordUserRequest {
    id?: number;

    constructor(data?: IResetPasswordUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResetPasswordUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IResetPasswordUserRequest {
    id?: number;
}

export class ResetPasswordUserResponse implements IResetPasswordUserResponse {
    ok?: boolean;
    newPassword?: string | undefined;

    constructor(data?: IResetPasswordUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordUserResponse {
    ok?: boolean;
    newPassword?: string | undefined;
}

export class ResetTenantBrandingResponse implements IResetTenantBrandingResponse {
    ok?: boolean;

    constructor(data?: IResetTenantBrandingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ResetTenantBrandingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetTenantBrandingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IResetTenantBrandingResponse {
    ok?: boolean;
}

export class ResetUserPasswordSendMailRequest implements IResetUserPasswordSendMailRequest {
    email?: string | undefined;

    constructor(data?: IResetUserPasswordSendMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResetUserPasswordSendMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordSendMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IResetUserPasswordSendMailRequest {
    email?: string | undefined;
}

export class ResetUserPasswordSendMailResponse implements IResetUserPasswordSendMailResponse {
    ok?: boolean;

    constructor(data?: IResetUserPasswordSendMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ResetUserPasswordSendMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordSendMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IResetUserPasswordSendMailResponse {
    ok?: boolean;
}

export class RoleDTO implements IRoleDTO {
    id?: number;
    name?: string | undefined;
    permissions?: PermissionDTO[] | undefined;
    dataStandardPermissions?: DataStandardPermissionDTO[] | undefined;
    pricingDatabasePermissions?: PricingDatabasePermissionDTO[] | undefined;

    constructor(data?: IRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionDTO.fromJS(item));
            }
            if (Array.isArray(_data["dataStandardPermissions"])) {
                this.dataStandardPermissions = [] as any;
                for (let item of _data["dataStandardPermissions"])
                    this.dataStandardPermissions!.push(DataStandardPermissionDTO.fromJS(item));
            }
            if (Array.isArray(_data["pricingDatabasePermissions"])) {
                this.pricingDatabasePermissions = [] as any;
                for (let item of _data["pricingDatabasePermissions"])
                    this.pricingDatabasePermissions!.push(PricingDatabasePermissionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataStandardPermissions)) {
            data["dataStandardPermissions"] = [];
            for (let item of this.dataStandardPermissions)
                data["dataStandardPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.pricingDatabasePermissions)) {
            data["pricingDatabasePermissions"] = [];
            for (let item of this.pricingDatabasePermissions)
                data["pricingDatabasePermissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoleDTO {
    id?: number;
    name?: string | undefined;
    permissions?: PermissionDTO[] | undefined;
    dataStandardPermissions?: DataStandardPermissionDTO[] | undefined;
    pricingDatabasePermissions?: PricingDatabasePermissionDTO[] | undefined;
}

export class RoleListDTO implements IRoleListDTO {
    id?: number;
    name?: string | undefined;

    constructor(data?: IRoleListDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleListDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleListDTO {
    id?: number;
    name?: string | undefined;
}

export class SaveDocumentationStageItem implements ISaveDocumentationStageItem {
    id?: number;
    name?: string | undefined;

    constructor(data?: ISaveDocumentationStageItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SaveDocumentationStageItem {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDocumentationStageItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISaveDocumentationStageItem {
    id?: number;
    name?: string | undefined;
}

export class SaveDocumentationStagesResponse implements ISaveDocumentationStagesResponse {
    ok?: boolean;
    error?: DocumentationStagesSaveError;
    conflictingNames?: string[] | undefined;
    stages?: DocumentationStageDTO[] | undefined;

    constructor(data?: ISaveDocumentationStagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.error = _data["error"];
            if (Array.isArray(_data["conflictingNames"])) {
                this.conflictingNames = [] as any;
                for (let item of _data["conflictingNames"])
                    this.conflictingNames!.push(item);
            }
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(DocumentationStageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDocumentationStagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDocumentationStagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["error"] = this.error;
        if (Array.isArray(this.conflictingNames)) {
            data["conflictingNames"] = [];
            for (let item of this.conflictingNames)
                data["conflictingNames"].push(item);
        }
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveDocumentationStagesResponse {
    ok?: boolean;
    error?: DocumentationStagesSaveError;
    conflictingNames?: string[] | undefined;
    stages?: DocumentationStageDTO[] | undefined;
}

export class SavePricingDatabaseSharingCommand implements ISavePricingDatabaseSharingCommand {
    tenantId?: number;
    pricingDatabases?: SharedPricingDatabaseDTO[] | undefined;

    constructor(data?: ISavePricingDatabaseSharingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["pricingDatabases"])) {
                this.pricingDatabases = [] as any;
                for (let item of _data["pricingDatabases"])
                    this.pricingDatabases!.push(SharedPricingDatabaseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePricingDatabaseSharingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SavePricingDatabaseSharingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.pricingDatabases)) {
            data["pricingDatabases"] = [];
            for (let item of this.pricingDatabases)
                data["pricingDatabases"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISavePricingDatabaseSharingCommand {
    tenantId?: number;
    pricingDatabases?: SharedPricingDatabaseDTO[] | undefined;
}

export class SavePricingDatabaseSharingResponse implements ISavePricingDatabaseSharingResponse {
    success?: boolean;

    constructor(data?: ISavePricingDatabaseSharingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SavePricingDatabaseSharingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SavePricingDatabaseSharingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISavePricingDatabaseSharingResponse {
    success?: boolean;
}

export class SaveTenantBrandingCommand implements ISaveTenantBrandingCommand {
    logoUrl?: string | undefined;
    logoMarkUrl?: string | undefined;
    faviconUrl?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    brandName?: string | undefined;
    urlSlug?: string | undefined;

    constructor(data?: ISaveTenantBrandingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoUrl = _data["logoUrl"];
            this.logoMarkUrl = _data["logoMarkUrl"];
            this.faviconUrl = _data["faviconUrl"];
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.brandName = _data["brandName"];
            this.urlSlug = _data["urlSlug"];
        }
    }

    static fromJS(data: any): SaveTenantBrandingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantBrandingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoUrl"] = this.logoUrl;
        data["logoMarkUrl"] = this.logoMarkUrl;
        data["faviconUrl"] = this.faviconUrl;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        data["brandName"] = this.brandName;
        data["urlSlug"] = this.urlSlug;
        return data;
    }
}

export interface ISaveTenantBrandingCommand {
    logoUrl?: string | undefined;
    logoMarkUrl?: string | undefined;
    faviconUrl?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    brandName?: string | undefined;
    urlSlug?: string | undefined;
}

export class SaveTenantBrandingResponse implements ISaveTenantBrandingResponse {
    ok?: boolean;
    branding?: TenantBrandingDTO;

    constructor(data?: ISaveTenantBrandingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.branding = _data["branding"] ? TenantBrandingDTO.fromJS(_data["branding"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveTenantBrandingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantBrandingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["branding"] = this.branding ? this.branding.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveTenantBrandingResponse {
    ok?: boolean;
    branding?: TenantBrandingDTO;
}

export class SaveTenantDocumentationStagesRequest implements ISaveTenantDocumentationStagesRequest {
    tenantId?: number;
    stages?: SaveDocumentationStageItem[] | undefined;

    constructor(data?: ISaveTenantDocumentationStagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(SaveDocumentationStageItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveTenantDocumentationStagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantDocumentationStagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveTenantDocumentationStagesRequest {
    tenantId?: number;
    stages?: SaveDocumentationStageItem[] | undefined;
}

export class SaveTenantHiddenPermissionsCommand implements ISaveTenantHiddenPermissionsCommand {
    tenantId?: number;
    permissions?: TenantPermissionVisibilityDTO[] | undefined;

    constructor(data?: ISaveTenantHiddenPermissionsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(TenantPermissionVisibilityDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveTenantHiddenPermissionsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantHiddenPermissionsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveTenantHiddenPermissionsCommand {
    tenantId?: number;
    permissions?: TenantPermissionVisibilityDTO[] | undefined;
}

export class SaveTenantHiddenPermissionsResponse implements ISaveTenantHiddenPermissionsResponse {
    success?: boolean;

    constructor(data?: ISaveTenantHiddenPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SaveTenantHiddenPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantHiddenPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISaveTenantHiddenPermissionsResponse {
    success?: boolean;
}

export class SaveTenantPermissionSettingsCommand implements ISaveTenantPermissionSettingsCommand {
    tenantId?: number;
    restrictModules?: boolean;
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;
    bimValidatorExpiryDate?: DateOnlyDto;
    budgetingExpiryDate?: DateOnlyDto;
    curveSolverExpiryDate?: DateOnlyDto;
    isoAnalyzerExpiryDate?: DateOnlyDto;
    slopeGuardExpiryDate?: DateOnlyDto;
    enumerationsAdministrationExpiryDate?: DateOnlyDto;
    ovCeExpiryDate?: DateOnlyDto;
    bimVitrinaExpiryDate?: DateOnlyDto;
    aiAskerExpiryDate?: DateOnlyDto;

    constructor(data?: ISaveTenantPermissionSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.restrictModules = _data["restrictModules"];
            this.hasBimValidator = _data["hasBimValidator"];
            this.hasBudgeting = _data["hasBudgeting"];
            this.hasCurveSolver = _data["hasCurveSolver"];
            this.hasIsoAnalyzer = _data["hasIsoAnalyzer"];
            this.hasSlopeGuard = _data["hasSlopeGuard"];
            this.hasEnumerationsAdministration = _data["hasEnumerationsAdministration"];
            this.hasOvCe = _data["hasOvCe"];
            this.hasBimVitrina = _data["hasBimVitrina"];
            this.hasAiAsker = _data["hasAiAsker"];
            this.bimValidatorExpiryDate = _data["bimValidatorExpiryDate"] ? DateOnlyDto.fromJS(_data["bimValidatorExpiryDate"]) : undefined as any;
            this.budgetingExpiryDate = _data["budgetingExpiryDate"] ? DateOnlyDto.fromJS(_data["budgetingExpiryDate"]) : undefined as any;
            this.curveSolverExpiryDate = _data["curveSolverExpiryDate"] ? DateOnlyDto.fromJS(_data["curveSolverExpiryDate"]) : undefined as any;
            this.isoAnalyzerExpiryDate = _data["isoAnalyzerExpiryDate"] ? DateOnlyDto.fromJS(_data["isoAnalyzerExpiryDate"]) : undefined as any;
            this.slopeGuardExpiryDate = _data["slopeGuardExpiryDate"] ? DateOnlyDto.fromJS(_data["slopeGuardExpiryDate"]) : undefined as any;
            this.enumerationsAdministrationExpiryDate = _data["enumerationsAdministrationExpiryDate"] ? DateOnlyDto.fromJS(_data["enumerationsAdministrationExpiryDate"]) : undefined as any;
            this.ovCeExpiryDate = _data["ovCeExpiryDate"] ? DateOnlyDto.fromJS(_data["ovCeExpiryDate"]) : undefined as any;
            this.bimVitrinaExpiryDate = _data["bimVitrinaExpiryDate"] ? DateOnlyDto.fromJS(_data["bimVitrinaExpiryDate"]) : undefined as any;
            this.aiAskerExpiryDate = _data["aiAskerExpiryDate"] ? DateOnlyDto.fromJS(_data["aiAskerExpiryDate"]) : undefined as any;
        }
    }

    static fromJS(data: any): SaveTenantPermissionSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantPermissionSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["restrictModules"] = this.restrictModules;
        data["hasBimValidator"] = this.hasBimValidator;
        data["hasBudgeting"] = this.hasBudgeting;
        data["hasCurveSolver"] = this.hasCurveSolver;
        data["hasIsoAnalyzer"] = this.hasIsoAnalyzer;
        data["hasSlopeGuard"] = this.hasSlopeGuard;
        data["hasEnumerationsAdministration"] = this.hasEnumerationsAdministration;
        data["hasOvCe"] = this.hasOvCe;
        data["hasBimVitrina"] = this.hasBimVitrina;
        data["hasAiAsker"] = this.hasAiAsker;
        data["bimValidatorExpiryDate"] = this.bimValidatorExpiryDate ? this.bimValidatorExpiryDate.toJSON() : undefined as any;
        data["budgetingExpiryDate"] = this.budgetingExpiryDate ? this.budgetingExpiryDate.toJSON() : undefined as any;
        data["curveSolverExpiryDate"] = this.curveSolverExpiryDate ? this.curveSolverExpiryDate.toJSON() : undefined as any;
        data["isoAnalyzerExpiryDate"] = this.isoAnalyzerExpiryDate ? this.isoAnalyzerExpiryDate.toJSON() : undefined as any;
        data["slopeGuardExpiryDate"] = this.slopeGuardExpiryDate ? this.slopeGuardExpiryDate.toJSON() : undefined as any;
        data["enumerationsAdministrationExpiryDate"] = this.enumerationsAdministrationExpiryDate ? this.enumerationsAdministrationExpiryDate.toJSON() : undefined as any;
        data["ovCeExpiryDate"] = this.ovCeExpiryDate ? this.ovCeExpiryDate.toJSON() : undefined as any;
        data["bimVitrinaExpiryDate"] = this.bimVitrinaExpiryDate ? this.bimVitrinaExpiryDate.toJSON() : undefined as any;
        data["aiAskerExpiryDate"] = this.aiAskerExpiryDate ? this.aiAskerExpiryDate.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaveTenantPermissionSettingsCommand {
    tenantId?: number;
    restrictModules?: boolean;
    hasBimValidator?: boolean;
    hasBudgeting?: boolean;
    hasCurveSolver?: boolean;
    hasIsoAnalyzer?: boolean;
    hasSlopeGuard?: boolean;
    hasEnumerationsAdministration?: boolean;
    hasOvCe?: boolean;
    hasBimVitrina?: boolean;
    hasAiAsker?: boolean;
    bimValidatorExpiryDate?: DateOnlyDto;
    budgetingExpiryDate?: DateOnlyDto;
    curveSolverExpiryDate?: DateOnlyDto;
    isoAnalyzerExpiryDate?: DateOnlyDto;
    slopeGuardExpiryDate?: DateOnlyDto;
    enumerationsAdministrationExpiryDate?: DateOnlyDto;
    ovCeExpiryDate?: DateOnlyDto;
    bimVitrinaExpiryDate?: DateOnlyDto;
    aiAskerExpiryDate?: DateOnlyDto;
}

export class SaveTenantPermissionSettingsResponse implements ISaveTenantPermissionSettingsResponse {
    success?: boolean;

    constructor(data?: ISaveTenantPermissionSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SaveTenantPermissionSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTenantPermissionSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISaveTenantPermissionSettingsResponse {
    success?: boolean;
}

export class SaveUserDataRequest implements ISaveUserDataRequest {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    isAdmin?: boolean;
    isTenantManager?: boolean;
    canCreateTenants?: boolean;
    language?: string | undefined;
    tenantId?: number;
    roleId?: number | undefined;

    constructor(data?: ISaveUserDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.isAdmin = _data["isAdmin"];
            this.isTenantManager = _data["isTenantManager"];
            this.canCreateTenants = _data["canCreateTenants"];
            this.language = _data["language"];
            this.tenantId = _data["tenantId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): SaveUserDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["isAdmin"] = this.isAdmin;
        data["isTenantManager"] = this.isTenantManager;
        data["canCreateTenants"] = this.canCreateTenants;
        data["language"] = this.language;
        data["tenantId"] = this.tenantId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ISaveUserDataRequest {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    isAdmin?: boolean;
    isTenantManager?: boolean;
    canCreateTenants?: boolean;
    language?: string | undefined;
    tenantId?: number;
    roleId?: number | undefined;
}

export class SaveUserDataResponse implements ISaveUserDataResponse {
    ok?: boolean;

    constructor(data?: ISaveUserDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SaveUserDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveUserDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISaveUserDataResponse {
    ok?: boolean;
}

export class SetUserPasswordResponse implements ISetUserPasswordResponse {
    ok?: boolean;
    email?: string | undefined;

    constructor(data?: ISetUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SetUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["email"] = this.email;
        return data;
    }
}

export interface ISetUserPasswordResponse {
    ok?: boolean;
    email?: string | undefined;
}

export class SharedPricingDatabaseDTO implements ISharedPricingDatabaseDTO {
    id?: number;
    name?: string | undefined;
    ownerTenantId?: number;
    ownerTenantName?: string | undefined;
    shared?: boolean;

    constructor(data?: ISharedPricingDatabaseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.ownerTenantId = _data["ownerTenantId"];
            this.ownerTenantName = _data["ownerTenantName"];
            this.shared = _data["shared"];
        }
    }

    static fromJS(data: any): SharedPricingDatabaseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SharedPricingDatabaseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["ownerTenantId"] = this.ownerTenantId;
        data["ownerTenantName"] = this.ownerTenantName;
        data["shared"] = this.shared;
        return data;
    }
}

export interface ISharedPricingDatabaseDTO {
    id?: number;
    name?: string | undefined;
    ownerTenantId?: number;
    ownerTenantName?: string | undefined;
    shared?: boolean;
}

export class SignupMicrosoftRequest implements ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignupMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignupMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;
}

export class SignupResponse implements ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;

    constructor(data?: ISignupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : undefined as any;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : undefined as any;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;
}

export class SignupUserMicrosoftRequest implements ISignupUserMicrosoftRequest {
    userId?: number;
    signupToken?: string | undefined;
    msToken?: string | undefined;

    constructor(data?: ISignupUserMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.signupToken = _data["signupToken"];
            this.msToken = _data["msToken"];
        }
    }

    static fromJS(data: any): SignupUserMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupUserMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["signupToken"] = this.signupToken;
        data["msToken"] = this.msToken;
        return data;
    }
}

export interface ISignupUserMicrosoftRequest {
    userId?: number;
    signupToken?: string | undefined;
    msToken?: string | undefined;
}

export class SignupUserMicrosoftResponse implements ISignupUserMicrosoftResponse {
    ok?: boolean;

    constructor(data?: ISignupUserMicrosoftResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SignupUserMicrosoftResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupUserMicrosoftResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISignupUserMicrosoftResponse {
    ok?: boolean;
}

export class StorePluginSessionTokensRequest implements IStorePluginSessionTokensRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;

    constructor(data?: IStorePluginSessionTokensRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): StorePluginSessionTokensRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StorePluginSessionTokensRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expires"] = this.expires ? this.expires.toISOString() : undefined as any;
        return data;
    }
}

export interface IStorePluginSessionTokensRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;
}

export class StorePluginSessionTokensResponse implements IStorePluginSessionTokensResponse {
    sessionId?: string | undefined;

    constructor(data?: IStorePluginSessionTokensResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): StorePluginSessionTokensResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StorePluginSessionTokensResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IStorePluginSessionTokensResponse {
    sessionId?: string | undefined;
}

export class TenantBrandingDTO implements ITenantBrandingDTO {
    logoUrl?: string | undefined;
    logoMarkUrl?: string | undefined;
    faviconUrl?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    brandName?: string | undefined;
    urlSlug?: string | undefined;

    constructor(data?: ITenantBrandingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoUrl = _data["logoUrl"];
            this.logoMarkUrl = _data["logoMarkUrl"];
            this.faviconUrl = _data["faviconUrl"];
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.brandName = _data["brandName"];
            this.urlSlug = _data["urlSlug"];
        }
    }

    static fromJS(data: any): TenantBrandingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBrandingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoUrl"] = this.logoUrl;
        data["logoMarkUrl"] = this.logoMarkUrl;
        data["faviconUrl"] = this.faviconUrl;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        data["brandName"] = this.brandName;
        data["urlSlug"] = this.urlSlug;
        return data;
    }
}

export interface ITenantBrandingDTO {
    logoUrl?: string | undefined;
    logoMarkUrl?: string | undefined;
    faviconUrl?: string | undefined;
    primaryColor?: string | undefined;
    secondaryColor?: string | undefined;
    brandName?: string | undefined;
    urlSlug?: string | undefined;
}

export class TenantDTO implements ITenantDTO {
    id?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;
    users?: TenantUserDTO[] | undefined;

    constructor(data?: ITenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.rsdApiKey = _data["rsdApiKey"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(TenantUserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["rsdApiKey"] = this.rsdApiKey;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantDTO {
    id?: number;
    name?: string | undefined;
    rsdApiKey?: string | undefined;
    users?: TenantUserDTO[] | undefined;
}

export class TenantListDto implements ITenantListDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantListDto {
    id?: number;
    name?: string | undefined;
}

export class TenantLoginDto implements ITenantLoginDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantLoginDto {
    id?: number;
    name?: string | undefined;
}

export class TenantPermissionVisibilityDTO implements ITenantPermissionVisibilityDTO {
    id?: number;
    name?: string | undefined;
    permissionType?: PermissionType;
    moduleType?: ModuleType;
    visible?: boolean;

    constructor(data?: ITenantPermissionVisibilityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.permissionType = _data["permissionType"];
            this.moduleType = _data["moduleType"];
            this.visible = _data["visible"];
        }
    }

    static fromJS(data: any): TenantPermissionVisibilityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantPermissionVisibilityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["permissionType"] = this.permissionType;
        data["moduleType"] = this.moduleType;
        data["visible"] = this.visible;
        return data;
    }
}

export interface ITenantPermissionVisibilityDTO {
    id?: number;
    name?: string | undefined;
    permissionType?: PermissionType;
    moduleType?: ModuleType;
    visible?: boolean;
}

export class TenantUserDTO implements ITenantUserDTO {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    isTenantManager?: boolean;
    canCreateTenants?: boolean;
    identityProvider?: string | undefined;
    language?: string | undefined;
    roleId?: number | undefined;
    belongsToOtherTenants?: boolean;

    constructor(data?: ITenantUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.isAdmin = _data["isAdmin"];
            this.isTenantManager = _data["isTenantManager"];
            this.canCreateTenants = _data["canCreateTenants"];
            this.identityProvider = _data["identityProvider"];
            this.language = _data["language"];
            this.roleId = _data["roleId"];
            this.belongsToOtherTenants = _data["belongsToOtherTenants"];
        }
    }

    static fromJS(data: any): TenantUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["isAdmin"] = this.isAdmin;
        data["isTenantManager"] = this.isTenantManager;
        data["canCreateTenants"] = this.canCreateTenants;
        data["identityProvider"] = this.identityProvider;
        data["language"] = this.language;
        data["roleId"] = this.roleId;
        data["belongsToOtherTenants"] = this.belongsToOtherTenants;
        return data;
    }
}

export interface ITenantUserDTO {
    id?: number;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    isAdmin?: boolean;
    isTenantManager?: boolean;
    canCreateTenants?: boolean;
    identityProvider?: string | undefined;
    language?: string | undefined;
    roleId?: number | undefined;
    belongsToOtherTenants?: boolean;
}

export class TokenRequest implements ITokenRequest {
    token?: string | undefined;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface ITokenRequest {
    token?: string | undefined;
}

export class UpdateRolePermissionsRequest implements IUpdateRolePermissionsRequest {
    role?: RoleDTO;

    constructor(data?: IUpdateRolePermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateRolePermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRolePermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateRolePermissionsRequest {
    role?: RoleDTO;
}

export class UpdateRolePermissionsResponse implements IUpdateRolePermissionsResponse {
    ok?: boolean;

    constructor(data?: IUpdateRolePermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateRolePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRolePermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateRolePermissionsResponse {
    ok?: boolean;
}

export class UpdateRoleRequest implements IUpdateRoleRequest {
    role?: RoleListDTO;

    constructor(data?: IUpdateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleListDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateRoleRequest {
    role?: RoleListDTO;
}

export class UpdateRoleResponse implements IUpdateRoleResponse {
    role?: RoleListDTO;

    constructor(data?: IUpdateRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleListDTO.fromJS(_data["role"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateRoleResponse {
    role?: RoleListDTO;
}

export class UserCreateModelDTO implements IUserCreateModelDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    msIdentity?: boolean;
    language?: string | undefined;
    userRole?: string | undefined;

    constructor(data?: IUserCreateModelDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.msIdentity = _data["msIdentity"];
            this.language = _data["language"];
            this.userRole = _data["userRole"];
        }
    }

    static fromJS(data: any): UserCreateModelDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateModelDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["msIdentity"] = this.msIdentity;
        data["language"] = this.language;
        data["userRole"] = this.userRole;
        return data;
    }
}

export interface IUserCreateModelDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    msIdentity?: boolean;
    language?: string | undefined;
    userRole?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}